import {css} from '@emotion/css';
import {useMemo} from 'react';

const useStyle = () => {
    return useMemo(
        () => ({
            wrapper: css({
                display: 'grid',
                gridTemplateRows: 'auto 1fr auto',
                height: '100%',
            }),
            button: css({
                display: 'flex',
                justifyContent: 'flex-end',
            }),
        }),
        []
    );
};

export default useStyle;
